module.exports = __webpack_public_path__ + "img/sitting_pretty_banner_image.f7a3bcf1.png";